var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMtgn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2271_634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0689 10.1486C16.0588 9.25268 17.1605 10.0386 18.4196 9.37318C20.5621 8.23883 19.4629 4.3249 16.6909 5.32303C14.5078 6.10896 15.0916 9.27101 14.0128 9.20814C12.4567 9.11645 12.8781 5.24182 8.9434 4.82266C6.76792 4.59212 5.25498 6.1797 5.48852 7.9297C5.7906 10.2036 8.3494 9.82116 8.34432 10.8507C8.3367 11.9641 4.72444 11.5816 4.14566 14.9061C3.49835 18.6314 10.1619 20.6591 12.0099 17.966C12.5607 17.1644 12.6064 15.9357 11.3753 15.1131C9.98164 14.1831 8.6794 11.9798 10.0629 10.146C10.6493 9.37056 12.1571 9.54871 12.4998 10.573C12.8603 11.6471 12.0226 12.0532 11.7256 12.7108C11.3017 13.5831 11.8322 14.4817 12.741 14.5813C13.5381 14.6677 13.9848 14.225 14.0178 13.6644C14.0737 12.7108 13.4848 12.7265 13.7005 11.9877C14.061 10.7512 16.6909 11.5214 16.0512 13.9368C15.7161 15.1995 14.1905 15.1838 14.1524 16.7976C14.1092 18.6629 15.8049 19.0742 17.229 19.0401C19.7345 18.9798 21.2119 17.2665 20.8464 14.2224C20.3463 10.0779 16.0816 11.3066 16.0689 10.1486Z",
    fill: "#050505"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtgn);
export default __webpack_public_path__ + "static/media/mtgn.baa37fafcc961f135c5e50d95139b491.svg";
export { ForwardRef as ReactComponent };